<template>
  <v-container class='pt-7 pb-11'>
    <h1 class='text-h4 mb-5'>{{ 'requestsBookingsPerformance'|localize }}</h1>
    <div class='white elevation-2 rounded mb-8'>
      <v-row class="my-0" align="center">
        <v-col class="py-0">
          <v-tabs v-model="tab" background-color="transparent" class="grey--text text--lighten-1">
            <v-tab :ripple="false" href="#by_transport_company" class="text-none">
              {{ 'myRequestsAndBookings'|localize }}
            </v-tab>
            <v-tab :ripple="false" href="#not_booked" class="text-none">
              {{ 'notBookedRequests'|localize }}
            </v-tab>
          </v-tabs>
        </v-col>
      </v-row>
      <v-divider class="mb-0"/>
      <AdminRequestsBookingsReports v-if='tab === "by_transport_company"' :companyScoped='true'/>
      <AdminNotBookedReports v-if='tab === "not_booked"' :companyScoped='true'/>
    </div>
  </v-container>
</template>

<script>
  import AdminRequestsBookingsReports from '@/components/AdminRequestsBookingsReports.vue';
  import AdminNotBookedReports from '@/components/AdminNotBookedReports.vue';

  export default {
    name: 'CompanyReports',
    components: {AdminNotBookedReports, AdminRequestsBookingsReports},

    data() {
      return {
        tab: 'by_transport_company'
      };
    }
  };
</script>
